import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ArrowRight, Gift, Wind, HeartHandshake, CheckCircle, Sparkles, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackEvent } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-8 px-4 pb-12 bg-[#FFF5F7]" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <FadeIn data-id="element-131">
          <div className="text-center mb-8" data-id="element-132">
            <p className="text-lg text-[#7a5568] mb-4" data-id="element-133">
              Esto nació de escuchar la misma frase una y otra vez
            </p>
            <h3 className="text-3xl md:text-5xl font-serif text-[#4a2535] italic mb-6" data-id="element-134">
              "Siento que hago todo… y aun así no alcanza."
            </h3>
            <p className="text-xl text-[#c4607a]" data-id="element-135">
              No era falta de amor. Era falta de herramientas reales.
            </p>
          </div>
        </FadeIn>

        <div className="bg-white p-8 md:p-12 rounded-3xl border border-[#f0d0dc] mb-8 shadow-[0_12px_40px_rgba(196,96,122,0.08)]" data-id="element-136">
          <FadeIn data-id="element-137">
            <h4 className="text-2xl font-serif text-[#2d1520] mb-8 text-center" data-id="element-138">
              Si hoy sentís que:
            </h4>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-139">
              {['Hablás y no te escucha', 'Siempre discuten por lo mismo', 'Te cansaste de ser la que intenta', 'Tenés miedo del desgaste silencioso'].map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-140">
                  <div className="bg-[#c4607a]/10 p-2 rounded-full" data-id="element-141">
                    <Check className="w-5 h-5 text-[#c4607a]" data-id="element-142" />
                  </div>
                  <span className="text-lg text-[#7a5568]" data-id="element-143">{item}</span>
                </div>)}
            </div>
            <div className="mt-6 text-center" data-id="element-144">
              <p className="text-3xl font-script text-[#c4607a]" data-id="element-145">
                Esto es para vos.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn data-id="element-146">
          <div className="text-center space-y-4" data-id="element-147">
            <p className="text-xl md:text-2xl text-[#4a2535] font-light" data-id="element-148">
              Antes de rendirte. Antes de apagarte. Antes de resignarte.
            </p>
            <p className="text-2xl md:text-3xl font-serif text-[#2d1520] font-bold" data-id="element-149">
              Leé esto.
            </p>

            <div id="precio" className="py-4" data-id="element-150">
              <p className="text-2xl md:text-4xl font-serif text-[#c4607a] mb-4" data-id="element-151">
                Porque no estás fallando. Lo estás haciendo bien.
              </p>

              <div className="mb-4" data-id="element-152">
                <p className="text-lg text-[#7a5568] mb-2" data-id="element-153">
                  Precio especial de lanzamiento
                </p>
                <div className="flex items-center justify-center gap-3" data-id="element-154">
                  <span className="text-2xl text-[#7a5568]/50 line-through decoration-[#c4607a]/40" data-id="element-155">
                    $19.800
                  </span>
                  <span className="text-5xl md:text-6xl font-serif font-bold text-[#c4607a]" data-id="element-156">
                    $9.900
                  </span>
                </div>
                <p className="text-sm text-[#7a5568] mt-2" data-id="element-157">
                  Acceso inmediato · Descarga digital
                </p>
              </div>

              <a href="https://www.reconectarhoy.com/cart/47802677297387:1" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('AddToCart')} className="group bg-[#c4607a] hover:bg-[#b35068] text-white px-10 py-5 rounded-full text-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-[0_4px_24px_rgba(196,96,122,0.25)] hover:shadow-[0_8px_40px_rgba(196,96,122,0.4)] flex items-center gap-3 mx-auto no-underline" data-id="element-158">
                Quiero mi guía y mis bonos
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-159" />
              </a>

              {/* Bono 1 */}
              <div className="mt-8 text-left" data-id="element-160">
                <div className="bg-white rounded-3xl border border-[#f0d0dc] shadow-[0_12px_40px_rgba(196,96,122,0.08)] overflow-hidden" data-id="element-161">
                  <div className="p-8 md:p-12" data-id="element-162">
                    <div className="flex flex-col md:flex-row gap-8 md:gap-12" data-id="element-163">
                      <div className="flex-1 space-y-6" data-id="element-164">
                        <div className="flex items-center gap-3" data-id="element-165">
                          <div className="bg-[#c4607a]/10 p-3 rounded-xl" data-id="element-166">
                            <Wind className="w-8 h-8 text-[#c4607a]" data-id="element-167" />
                          </div>
                          <div data-id="element-168">
                            <span className="text-sm font-bold text-[#c4607a] uppercase tracking-wider block" data-id="element-169">
                              Bono 1
                            </span>
                            <h3 className="text-2xl md:text-3xl font-serif text-[#2d1520] font-bold" data-id="element-170">
                              Antes de Hablar, Respirá
                            </h3>
                          </div>
                        </div>

                        <div className="bg-[#FEF0F3] p-4 rounded-lg border border-[#f0d0dc] inline-block" data-id="element-171">
                          <p className="text-[#7a5568] font-medium" data-id="element-172">
                            Valor real:{' '}
                            <span className="line-through opacity-60" data-id="element-173">
                              $47.000
                            </span>{' '}
                            —{' '}
                            <span className="text-[#c4607a] font-bold" data-id="element-174">
                              Hoy incluido sin costo adicional
                            </span>
                          </p>
                        </div>

                        <p className="text-xl font-serif text-[#4a2535] italic" data-id="element-175">
                          El método interno para calmar tus emociones antes de
                          decir algo que no podés desdecir
                        </p>

                        <div className="space-y-4 text-[#7a5568] leading-relaxed" data-id="element-176">
                          <p data-id="element-177">
                            Hay algo que nadie te explicó sobre las peleas de
                            pareja.
                          </p>
                          <p data-id="element-178">
                            No es lo que decís lo que más daño hace. Es el
                            estado emocional desde el que lo decís.
                          </p>
                          <p data-id="element-179">
                            Podés tener las mejores intenciones. Podés querer
                            comunicarte mejor. Podés haber leído todo el libro.
                          </p>
                          <p data-id="element-180">
                            Pero si hablás cuando estás activada, herida o
                            enojada… la conversación ya empieza torcida.
                          </p>
                          <p className="font-medium text-[#4a2535]" data-id="element-181">
                            Antes de Hablar, Respirá es el recurso que evita que
                            el conflicto escale antes de empezar.
                          </p>
                        </div>

                        <div className="bg-[#FFF5F7] p-6 rounded-2xl border border-[#f0d0dc]" data-id="element-182">
                          <h4 className="font-serif text-lg text-[#2d1520] mb-4 flex items-center gap-2" data-id="element-183">
                            <Sparkles className="w-5 h-5 text-[#c4607a]" data-id="element-184" />
                            En este bono vas a aprender:
                          </h4>
                          <ul className="space-y-3" data-id="element-185">
                            {['Cómo identificar cuándo tu sistema nervioso está en modo ataque', 'Qué señales corporales indican que no es momento de hablar', 'El protocolo de pausa consciente en 5 pasos', 'Cómo diferenciar emoción actual de herida vieja', 'Cómo prepararte para conversaciones difíciles sin explotar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-186">
                                <CheckCircle className="w-5 h-5 text-[#c4607a] shrink-0 mt-0.5" data-id="element-187" />
                                <span className="text-[#7a5568]" data-id="element-188">{item}</span>
                              </li>)}
                          </ul>
                        </div>

                        <div className="space-y-4 text-[#7a5568] leading-relaxed border-t border-[#f0d0dc] pt-6" data-id="element-189">
                          <p data-id="element-190">Este no es un complemento opcional.</p>
                          <p data-id="element-191">
                            Es la pieza que hace que todo el método funcione
                            incluso en los días difíciles.
                          </p>
                          <p data-id="element-192">
                            Si este recurso se vendiera por separado, tendría un
                            valor mínimo de $27.000. Porque evita discusiones
                            innecesarias, palabras que duelen y distancias que
                            luego cuestan semanas reparar.
                          </p>
                          <p data-id="element-193">Pero hoy no lo vas a pagar.</p>
                          <p data-id="element-194">
                            Está incluido sin costo adicional dentro de tu
                            acceso.
                          </p>
                          <p data-id="element-195">
                            No para que lo leas una vez. Sino para que lo uses
                            cada vez que sientas que la conversación puede irse
                            de las manos.
                          </p>
                          <p className="text-[#c4607a] font-serif text-lg" data-id="element-196">
                            Porque aprender a hablar mejor es importante. Pero
                            aprender a regularte antes de hablar lo cambia todo.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bono 2 */}
              <div className="mt-8 text-left" data-id="element-197">
                <div className="bg-white rounded-3xl border border-[#f0d0dc] shadow-[0_12px_40px_rgba(196,96,122,0.08)] overflow-hidden" data-id="element-198">
                  <div className="p-8 md:p-12" data-id="element-199">
                    <div className="flex flex-col md:flex-row gap-8 md:gap-12" data-id="element-200">
                      <div className="flex-1 space-y-6" data-id="element-201">
                        <div className="flex items-center gap-3" data-id="element-202">
                          <div className="bg-[#c4607a]/10 p-3 rounded-xl" data-id="element-203">
                            <HeartHandshake className="w-8 h-8 text-[#c4607a]" data-id="element-204" />
                          </div>
                          <div data-id="element-205">
                            <span className="text-sm font-bold text-[#c4607a] uppercase tracking-wider block" data-id="element-206">
                              Bono 2
                            </span>
                            <h3 className="text-2xl md:text-3xl font-serif text-[#2d1520] font-bold" data-id="element-207">
                              El Juego de la Conexión Real
                            </h3>
                          </div>
                        </div>

                        <div className="bg-[#FEF0F3] p-4 rounded-lg border border-[#f0d0dc] inline-block" data-id="element-208">
                          <p className="text-[#7a5568] font-medium" data-id="element-209">
                            Valor real:{' '}
                            <span className="line-through opacity-60" data-id="element-210">
                              $47.000
                            </span>{' '}
                            —{' '}
                            <span className="text-[#c4607a] font-bold" data-id="element-211">
                              Hoy incluido sin costo adicional
                            </span>
                          </p>
                        </div>

                        <p className="text-xl font-serif text-[#4a2535] italic" data-id="element-212">
                          Dinámicas simples para reconectar en pareja sin tener
                          que hablar de problemas
                        </p>

                        <div className="space-y-4 text-[#7a5568] leading-relaxed" data-id="element-213">
                          <p data-id="element-214">
                            Hay parejas que no se separan por falta de amor. Se
                            desgastan por exceso de conversaciones pesadas.
                          </p>
                          <p data-id="element-215">
                            "Tenemos que hablar" se vuelve una amenaza. Todo
                            gira alrededor de conflictos. Y la conexión empieza
                            a desaparecer.
                          </p>
                          <p data-id="element-216">
                            El Juego de la Conexión Real nace para resolver eso.
                          </p>
                          <p className="font-medium text-[#4a2535]" data-id="element-217">
                            No es un libro para analizar la relación. Es una
                            experiencia para volver a sentirse cerca.
                          </p>
                        </div>

                        <div className="bg-[#FFF5F7] p-6 rounded-2xl border border-[#f0d0dc]" data-id="element-218">
                          <h4 className="font-serif text-lg text-[#2d1520] mb-4 flex items-center gap-2" data-id="element-219">
                            <Users className="w-5 h-5 text-[#c4607a]" data-id="element-220" />
                            En este bono vas a encontrar:
                          </h4>
                          <ul className="space-y-3" data-id="element-221">
                            {['Micro dinámicas diarias de 5 minutos', 'Preguntas que abren sin generar defensa', 'Rituales simples para parejas con poco tiempo', 'Ejercicios para reconectar después de una pelea', 'Adaptaciones reales para parejas con hijos y rutina intensa'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-222">
                                <CheckCircle className="w-5 h-5 text-[#c4607a] shrink-0 mt-0.5" data-id="element-223" />
                                <span className="text-[#7a5568]" data-id="element-224">{item}</span>
                              </li>)}
                          </ul>
                        </div>

                        <div className="bg-[#c4607a]/5 p-6 rounded-xl border-l-4 border-[#c4607a]" data-id="element-225">
                          <p className="text-[#4a2535] italic" data-id="element-226">
                            Este recurso está diseñado para algo muy concreto:{' '}
                            <br data-id="element-227" />
                            <span className="font-bold" data-id="element-228">
                              Que vuelvan a sentirse equipo sin necesidad de
                              discutir nada.
                            </span>
                          </p>
                        </div>

                        <div className="space-y-4 text-[#7a5568] leading-relaxed border-t border-[#f0d0dc] pt-6" data-id="element-229">
                          <p data-id="element-230">
                            Si se ofreciera como producto independiente, su
                            valor sería de $27.000. Porque transforma la
                            atmósfera emocional de la relación sin esfuerzo
                            terapéutico.
                          </p>
                          <p data-id="element-231">Pero hoy no lo vas a pagar.</p>
                          <p data-id="element-232">Está incluido sin costo adicional.</p>
                          <p data-id="element-233">
                            Para que no todo en tu relación sea resolver
                            problemas. Para que también haya momentos livianos.
                            Para que la conexión no dependa siempre de una
                            conversación profunda.
                          </p>
                          <p className="text-[#c4607a] font-serif text-lg" data-id="element-234">
                            Porque a veces no hace falta entender más. Hace
                            falta volver a sentirse cerca.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bonuses Section */}

            <motion.div className="mt-6 flex justify-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 1
          }} data-id="element-235">
              <img src="https://cdn.magicpatterns.com/uploads/23xQnoLCh3GWCv8zaG2H5B/LO_ESTAS_HACIENDO_BIEN_1X1_IMAGEN.png" alt="Lo Estás Haciendo Bien" className="w-32 h-32 rounded-lg shadow-[0_8px_24px_rgba(196,96,122,0.15)] opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-236" />
            </motion.div>
          </div>
        </FadeIn>
      </div>
    </section>;
}